import { render } from "./HubPackages.vue?vue&type=template&id=05e72bbe&scoped=true&ts=true"
import script from "./HubPackages.vue?vue&type=script&lang=ts"
export * from "./HubPackages.vue?vue&type=script&lang=ts"

import "./HubPackages.vue?vue&type=style&index=0&id=05e72bbe&scoped=true&lang=css"

import exportComponent from "/var/www/html/lmd-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05e72bbe"]])

export default __exports__